import { Directive, ViewContainerRef, inject, input } from '@angular/core';
import { UserModel } from '../../../core/models/user/user.model';

@Directive({
  selector: '[appEventSlot]',
  standalone: true,
})
export class EventSlotDirective {
  member = input.required<UserModel>();
  date = input.required<Date>();
  eventContainer = input.required<HTMLDivElement>();
  public vcr = inject(ViewContainerRef);
}
